import Swipeout from './Swipeout';
export default Swipeout;